import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {CandidateModel} from "../../../../models/candidate.model";
import {VoteType, VoteTypes} from "../../../../types";
import {VoteModel} from "../../../../models/vote.model";

@Component({
  selector: 'app-vote-card',
  templateUrl: './vote-card.component.html',
  styleUrls: ['./vote-card.component.scss']
})
export class VoteCardComponent implements OnInit {
  @Input() candidate: CandidateModel;
  @Input() count: number;
  @Input() allowedVotes: number;
  @Output() readonly voteValue = new EventEmitter<VoteModel>();
  readonly voteTypes = VoteTypes;
  voteType = VoteTypes.MA_ABTIN;
  voted = true;

  ngOnInit(): void {
    this.emitVote();
  }

  isSelected(voteType: VoteType): boolean {
    return this.voted && this.voteType === voteType;
  }

  isDisabled(voteType: VoteType): boolean {
    return !this.isSelected(voteType) && this.count > this.allowedVotes
  }

  vote(voteType: VoteType): void {
    if ((this.voted && this.isSelected(voteType)) || !this.voted) {
      this.voted = !this.voted;
    }
    this.voteType = voteType;
    this.emitVote();
  }

  emitVote(): void {
    const vote: VoteModel = {
      vote: this.voteType,
      candidateId: this.candidate.id
    }
    this.voteValue.emit(vote);
  }
}
